import React from 'react'
import { Link } from 'react-router-dom'

import { formatDate } from '../../utils/formatDate'

import { ReportStatusBadge } from './CaseResultRow'
import { getCaseStatusMeta } from './caseStatusHelpers'

/** @typedef { import('../../services/types/CaseSearchResultItem').CaseSearchResultItem } CaseSearchResultItem */

/**
 * @param {{ rowData: CaseSearchResultItem, onMemberClick?: (name: string) => void, settings?: any }} props
 */
export function CaseResultCard({ rowData, onMemberClick, settings }) {
  const linkHref = `/cases/${rowData.caseNumber}?returnTo=/cases`
  const caseStatusMeta = getCaseStatusMeta(rowData.status)

  return (
    <div className="col-xl-4 col-md-6 mb-3">
      <div className="card h-100 shadow-sm case-result-card">
        <div className="card-body d-flex flex-column p-3">
          <div className="d-flex justify-content-between align-items-start mb-2">
            <div className="pr-2 min-w-0">
              <Link to={linkHref} className="case-result-card__title d-block text-truncate">
                {rowData.clientFullName}
              </Link>
              <div className="case-result-card__subtitle text-muted small text-truncate">
                {rowData.caseTypeName && <span>{rowData.caseTypeName}</span>}
                {rowData.caseTypeName && rowData.company && <span className="mx-1">&bull;</span>}
                {rowData.company && <span>{rowData.company}</span>}
              </div>
            </div>
            <span className={`case-status-indicator ${caseStatusMeta.variantClass} flex-shrink-0`}>
              <span className="case-status-indicator__dot" />
              <span>{caseStatusMeta.label}</span>
            </span>
          </div>

          <div className="case-result-card__meta small text-muted mb-3">
            <div className="d-flex justify-content-between mb-1">
              <span>Opened: {formatDate(rowData.createdUtc) || '—'}</span>
              {rowData.lastUpdatedUtc && <span>Updated: {formatDate(rowData.lastUpdatedUtc)}</span>}
            </div>
            {rowData.members && rowData.members.length > 0 && (
              <div className="text-truncate" title={rowData.members.map(m => m.fullName).join(', ')}>
                <span className="text-secondary font-weight-bold mr-1">Members:</span>
                {rowData.members.map((member, idx) => (
                  <React.Fragment key={member.id || idx}>
                    {idx > 0 && ', '}
                    <a
                      href="#!"
                      className="member-filter-link"
                      onClick={e => {
                        e.preventDefault()
                        onMemberClick?.(member.fullName)
                      }}
                    >
                      {member.fullName}
                    </a>
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>

          <div className="mt-auto pt-2 border-top d-flex justify-content-between align-items-center case-result-card__footer">
            <span className="case-result-card__report-label text-muted small font-weight-bold text-uppercase">
              Report Status
            </span>
            <ReportStatusBadge rowData={rowData} settings={settings} showEmptyLabel />
          </div>
        </div>
      </div>
    </div>
  )
}
